/* Meubelhunter — redesign PDP: live updates bij variantwissel
   (prijs, van-prijs, korting%, iDEAL-termijn, levertijd/voorraad) + scroll naar reviews. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mhp]');
  if (!root) return;

  var map = {};
  var mapEl = document.querySelector('[data-mhp-variants]');
  if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) {} }

  /* ---------- Aantal-stepper (alleen bij variant-foto-producten) ----------
     Bij producten met variant-eigen foto's ontbreekt Empire's [data-product-gallery];
     Empire's ProductDetails crasht daardoor bij het bouwen van de ProductGallery en
     bindt de +/- knoppen NIET. Op die producten binden we de stepper zelf.
     Bij de rest laat Empire de stepper met rust (geen dubbele binding). */
  if (root.hasAttribute('data-mhp-selfqty')) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
      if (!btn) return;
      var wrap = btn.closest('quantity-selector, [data-quantity-selector], .quantity-selector');
      var input = wrap && wrap.querySelector('[data-quantity-input]');
      if (!input) return;
      e.preventDefault();
      var step = parseInt(input.getAttribute('step'), 10) || parseInt(input.getAttribute('data-increment-value'), 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || step || 1;
      var cur = parseInt(input.value, 10);
      if (isNaN(cur)) cur = min;
      var next = btn.hasAttribute('data-quantity-plus') ? cur + step : cur - step;
      if (step > 1) next = Math.round(next / step) * step; // veelvoud van step (per-2)
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      var minusWrap = wrap.querySelector('[data-button-wrapper-minus]');
      if (minusWrap) minusWrap.classList.toggle('quantity-selector__button-wrapper--disabled', next <= min);
    });
  }

  var idField = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');
  var priceEl = root.querySelector('[data-mhp-price]');
  var compareEl = root.querySelector('[data-mhp-compare]');
  var discEl = root.querySelector('[data-mhp-discount]');
  var termijnEl = root.querySelector('[data-mhp-termijn]');
  var delivEl = root.querySelector('[data-mhp-delivery-text]');
  var delivDot = root.querySelector('[data-mhp-delivery-dot]');
  var stockEl = root.querySelector('[data-mhp-stock]');

  function update(id) {
    var key = id != null ? ('' + id) : (idField ? idField.value : null);
    if (!key) return;
    var v = map[key];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.price;
    if (compareEl) {
      if (v.has_compare > 0) { compareEl.textContent = v.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (discEl) {
      if (v.discount > 0) { discEl.textContent = '−' + v.discount + '%'; discEl.hidden = false; }
      else { discEl.hidden = true; }
    }
    if (termijnEl) termijnEl.textContent = v.termijn;
    if (stockEl) stockEl.textContent = v.stock;
    if (delivEl) delivEl.textContent = v.delivery;
    if (delivDot) {
      delivDot.classList.remove('mhp-delivery__dot--soon', 'mhp-delivery__dot--request');
      var ds = v.dot || (v.instock ? 'ok' : 'soon');
      if (ds === 'request') delivDot.classList.add('mhp-delivery__dot--request');
      else if (ds === 'soon') delivDot.classList.add('mhp-delivery__dot--soon');
    }
  }

  // Empire's <variant-selection> dispatcht een 'variant-change' CustomEvent (geen native change).
  var vsel = document.querySelector('[data-variant-selection]');
  // Na een korte init-venster: bij variantwissel op mobiel naar boven scrollen,
  // zodat de gebruiker meteen de foto's van de gekozen variant ziet.
  var mhpScrollReady = false;
  setTimeout(function () { mhpScrollReady = true; }, 900);
  if (vsel) {
    vsel.addEventListener('variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) update(v.id);
      if (mhpScrollReady && window.matchMedia('(max-width: 989px)').matches) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
  // Fallback: native change op het id-veld.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') update();
  });

  // ===== Variant-galerij: swipe-carousel met eigen foto's per variant =====
  // Alle foto's van de variant staan als slides in één track (vooraf geladen via
  // srcset -> snel, geen laad-hapering bij swipe). Mobiel: finger-follow drag die
  // de foto met je vinger meebeweegt en op release doorschuift/terugveert. Desktop:
  // pijltjes. Clones voor/achter = naadloze loop (laatste -> eerste zonder sprong).
  var mhvg = document.querySelector('[data-mhvg]');
  if (mhvg) {
    var vmap = {};
    try { vmap = JSON.parse(mhvg.querySelector('[data-mhvg-map]').textContent); } catch (e) {}
    var mhvgThumbs = mhvg.querySelector('[data-mhvg-thumbs]');
    var mhvgView = mhvg.querySelector('[data-mhvg-main]');   // overflow-viewport
    var mhvgTrack = mhvg.querySelector('[data-mhvg-track]');
    var VG_SIZES = '(max-width: 749px) 100vw, 600px';
    var VG_DUR = 300;                         // snap-animatie (ms)
    var vgN = 0, vgPhys = 0, vgW = 0, vgPending = null;

    function vgEsc(s) { return ('' + (s == null ? '' : s)).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
    function vgMeasure() { var r = mhvgView.getBoundingClientRect(); vgW = r.width || mhvgView.clientWidth || 0; }
    function vgSetX(px, animate) {
      mhvgTrack.style.transition = animate ? ('transform ' + VG_DUR + 'ms cubic-bezier(.22,.61,.36,1)') : 'none';
      mhvgTrack.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    function vgPlace(animate) { vgSetX(-vgPhys * vgW, animate); }
    // physical index -> echte foto-index (0 = clone van laatste, vgN+1 = clone van eerste)
    function vgReal(p) { if (p === 0) return vgN - 1; if (p === vgN + 1) return 0; return p - 1; }
    function vgSyncThumbs(real) {
      var btns = mhvgThumbs.querySelectorAll('.mhvg__thumb');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', i === real);
      var act = btns[real];
      if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    // Rond een lopende clone-reset direct af (bij interruptie/nieuwe actie).
    function vgSettle() {
      if (!vgPending) return;
      clearTimeout(vgPending); vgPending = null;
      if (vgPhys === 0) vgPhys = vgN; else if (vgPhys === vgN + 1) vgPhys = 1;
      vgPlace(false);
    }
    // Eén stap: dir=+1 volgende, -1 vorige. Animeert; springt daarna onzichtbaar
    // terug van de clone naar het echte slide -> naadloze loop.
    function vgGo(dir) {
      if (vgN < 2) return;
      vgSettle();
      vgPhys += dir;
      vgPlace(true);
      vgSyncThumbs(vgReal(vgPhys));
      if (vgPhys === 0 || vgPhys === vgN + 1) {
        vgPending = setTimeout(function () {
          vgPending = null;
          vgPhys = (vgPhys === 0) ? vgN : 1;
          vgPlace(false);
        }, VG_DUR + 30);
      }
    }
    // Directe sprong naar foto (thumbnail-klik).
    function vgJump(real) {
      if (vgN < 2) { return; }
      vgSettle();
      vgPhys = real + 1;
      vgPlace(true);
      vgSyncThumbs(real);
    }
    // Bouw de track (met clones) + thumbs voor een variant.
    function vgBuild(vid) {
      var imgs = vmap['' + vid];
      if (!imgs || !imgs.length) return;
      vgN = imgs.length;
      mhvgThumbs.innerHTML = imgs.map(function (im, i) {
        return '<button type="button" class="mhvg__thumb" data-mhvg-thumb aria-label="Foto ' + (i + 1) + '">' +
          '<img src="' + im.t + '" alt="" loading="lazy" width="76" height="76"></button>';
      }).join('');
      function slide(im) {
        return '<div class="mhvg__slide"><img src="' + im.f + '" srcset="' + im.ss + '" sizes="' + VG_SIZES +
          '" alt="' + vgEsc(im.a) + '" width="800" height="800" draggable="false"></div>';
      }
      var html = '';
      if (vgN > 1) html += slide(imgs[vgN - 1]);   // leading clone (= laatste)
      html += imgs.map(slide).join('');
      if (vgN > 1) html += slide(imgs[0]);         // trailing clone (= eerste)
      mhvgTrack.innerHTML = html;
      vgMeasure();
      vgPhys = (vgN > 1) ? 1 : 0;
      vgPlace(false);
      vgSyncThumbs(0);
      if (!vgW) requestAnimationFrame(function () { vgMeasure(); vgPlace(false); });
    }

    // thumbnail-klik
    mhvgThumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mhvg-thumb]'); if (!t) return;
      var btns = [].slice.call(mhvgThumbs.querySelectorAll('.mhvg__thumb'));
      var i = btns.indexOf(t); if (i >= 0) vgJump(i);
    });
    // pijltjes (desktop)
    var vgPrev = mhvg.querySelector('[data-mhvg-prev]');
    var vgNext = mhvg.querySelector('[data-mhvg-next]');
    if (vgPrev) vgPrev.addEventListener('click', function () { vgGo(-1); });
    if (vgNext) vgNext.addEventListener('click', function () { vgGo(1); });

    // swipe (finger-follow): de track beweegt live met de vinger mee.
    var vgDrag = false, vgSX = 0, vgSY = 0, vgBase = 0, vgDecided = false, vgHoriz = false;
    mhvgView.addEventListener('touchstart', function (e) {
      if (vgN < 2) return;
      vgSettle(); vgMeasure();
      vgDrag = true; vgDecided = false; vgHoriz = false;
      var t = e.touches[0]; vgSX = t.clientX; vgSY = t.clientY;
      vgBase = -vgPhys * vgW;
      vgSetX(vgBase, false);
    }, { passive: true });
    mhvgView.addEventListener('touchmove', function (e) {
      if (!vgDrag) return;
      var t = e.touches[0];
      var dx = t.clientX - vgSX, dy = t.clientY - vgSY;
      if (!vgDecided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        vgDecided = true; vgHoriz = Math.abs(dx) > Math.abs(dy);
      }
      if (!vgHoriz) return;            // verticaal: laat de pagina scrollen
      e.preventDefault();
      if (dx > vgW) dx = vgW; else if (dx < -vgW) dx = -vgW;
      vgSetX(vgBase + dx, false);
    }, { passive: false });
    function vgEnd(e) {
      if (!vgDrag) return; vgDrag = false;
      if (!vgHoriz) return;
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      var dx = t ? (t.clientX - vgSX) : 0;
      var thresh = Math.min(60, vgW * 0.18);
      if (dx <= -thresh) vgGo(1);
      else if (dx >= thresh) vgGo(-1);
      else vgPlace(true);             // te klein: terugveren
    }
    mhvgView.addEventListener('touchend', vgEnd, { passive: true });
    mhvgView.addEventListener('touchcancel', vgEnd, { passive: true });

    // resize -> slidebreedte herberekenen
    var vgRT;
    window.addEventListener('resize', function () {
      clearTimeout(vgRT);
      vgRT = setTimeout(function () { vgSettle(); vgMeasure(); vgPlace(false); }, 120);
    });

    // variantwissel -> foto-set van die variant (reset naar eerste)
    if (vsel) {
      vsel.addEventListener('variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id) vgBuild(v.id);
      });
    }
    // init
    vgBuild(mhvg.getAttribute('data-mhvg-sel'));
  }

  // Vertrouwensbadge -> smooth scroll naar social proof.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mhp-scrollto]');
    if (t) {
      var target = document.querySelector(t.getAttribute('data-mhp-scrollto'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    // Omschrijving "Lees meer"
    var more = e.target.closest('[data-mhp-desc-toggle]');
    if (more) {
      var body = document.querySelector('[data-mhp-desc]');
      if (body) {
        var clamped = body.classList.toggle('is-clamped');
        more.firstChild.textContent = clamped ? 'Lees meer ' : 'Lees minder ';
      }
    }
  });

  // Aantal-stepper: NIET meer zelf binden. Sinds we [data-product-form-area]
  // toevoegden (voor de variant-fotoswap) initialiseert Empire's ProductDetails
  // volledig en beheert Empire's eigen <quantity-selector> de +/- (respecteert
  // min/step/max + minus-disable). Een eigen stepper hier gaf een DUBBELE binding
  // -> elke klik telde 2x de step (bij per-2 stoelen: 2->6->10). Empire doet 't nu.

  // "Maak het compleet" — voegt huidig product + de 2 complementen in één keer toe.
  // Via de cart-drawer-API (window.MHCartDrawer.addItems) -> zelfde sections-flow
  // als de gewone add-to-cart, dus verse drawer-HTML direct (geen refresh-race).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mh-bundle-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var form = document.querySelector('[data-product-form], form[action*="/cart/add"]');
    var idField = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[data-quantity-input], [name="quantity"]');
    var items = [];
    // huidig product — respecteer de gekozen hoeveelheid (dus ook per-2)
    if (idField && idField.value && idField.value !== 'not-selected') {
      items.push({ id: Number(idField.value), quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1 });
    }
    // complementen — "id:qty,id:qty" (qty = 2 voor per-2 producten)
    (btn.getAttribute('data-variants') || '').split(',').forEach(function (pair) {
      pair = pair.trim(); if (!pair) return;
      var p = pair.split(':');
      var id = (p[0] || '').trim();
      if (id) items.push({ id: Number(id), quantity: parseInt(p[1], 10) || 1 });
    });
    if (!items.length) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Toevoegen…';
    function done() { btn.textContent = 'Toegevoegd ✓'; }
    function fail() { btn.disabled = false; btn.textContent = orig; }
    if (window.MHCartDrawer && window.MHCartDrawer.addItems) {
      window.MHCartDrawer.addItems(items).then(done, fail);
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); var o = document.querySelector('[data-cart-drawer-open], .site-header-cart--button'); if (o) { o.click(); } else { window.location = '/cart'; } done(); })
        .catch(fail);
    }
  });
})();
